import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSaveTrue$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSaveTrue extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c019631f908b7d00c718664985c23f33cca96198', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '07fb30c1cbcda38596047571f75ad0066081b037', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd8377c021e7b704a192cbaa3a45d1a0628f03800', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.9 12.713a.5.5 0 0 0 .36-.153L17 6a.49.49 0 0 0-.01-.67L16.61 5a.5.5 0 0 0-.7 0l-5.07 5.83L7.71 7.9a.51.51 0 0 0-.71 0l-.35.39a.5.5 0 0 0 0 .71l3.89 3.56a.5.5 0 0 0 .36.153M3.5 19h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H18a.5.5 0 0 0-.5.5v4h-13v-4A.5.5 0 0 0 4 13h-.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-save-true", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-save-true"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-save-true":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSaveTrue$1);
            }
            break;
    } });
}

const CosmosIconSaveTrue = CosmosIconSaveTrue$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSaveTrue, defineCustomElement };
